document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".payment-response-container");
  if (!container) return;

  // Add smooth reveal animation
  container.style.opacity = "0";
  container.style.transform = "translateY(20px)";

  requestAnimationFrame(() => {
    container.style.transition = "opacity 0.5s ease, transform 0.5s ease";
    container.style.opacity = "1";
    container.style.transform = "translateY(0)";
  });

  // Handle button clicks
  const buttons = container.querySelectorAll(".button");
  buttons.forEach((button) => {
    button.addEventListener("click", (e) => {
      e.target.style.transform = "scale(0.98)";
      setTimeout(() => {
        e.target.style.transform = "scale(1)";
      }, 100);
    });
  });
});
